<template class="spacer-bottom-xl">
  <div>
    <div class="z-title z-title--micro spacer-bottom-m">
      Rematrícula
    </div>

    <div v-if="hasFee">
      <p class="z-text spacer-bottom-l">
        A taxa de rematrícula é uma exigência das instituições de ensino, mas não se preocupe.
        O pagamento é feito com toda a facilidade do Quero Pago que você já conhece.
      </p>
    </div>
    <div v-else-if="isAmountWithoutDiscount">
      <p class="z-text spacer-bottom-l">
        O valor da rematrícula equivale ao <b>valor atualizado da sua primeira mensalidade</b>
        do próximo período.
      </p>
    </div>
    <div v-else>
      <p class="z-text spacer-bottom-l">
        O valor da rematrícula equivale ao <b>valor atualizado da sua primeira mensalidade com desconto</b>
        do próximo período.
      </p>
    </div>

    <div class="z-card z-card--centered-content spacer-bottom-l">
      <div class="z-title z-title--larger z-title--center spacer-bottom-m">
        {{ reenrollment.bill.bill_value | formatCurrency }}
      </div>

      <p class="z-text z-text--small z-text--center">
        O pagamento da rematrícula garante sua vaga no próximo período.
      </p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    reenrollment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    feeType() {
      return this.reenrollment.fee_type;
    },
    hasFee() {
      const feeTypes = [
        'reenrollment_fee',
        'equivalent_to_first_bill_with_discount',
        'equivalent_to_first_bill_without_discount',
      ];

      return feeTypes.includes(this.feeType);
    },
    isAmountWithoutDiscount() {
      return this.feeType === 'first_bill_without_discount';
    },
  },
};
</script>
